import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-uxdesign',
  templateUrl: './uxdesign.component.html',
  styleUrls: ['./uxdesign.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class UxdesignComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
